import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, DropletIcon, SmartphoneIcon, TreesIcon, ShieldCheckIcon, WalletIcon } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <ZapIcon className="w-8 h-8" data-id="element-84" />,
    title: 'Energetická soběstačnost',
    description: 'NO BLACKOUT HOUSE – první v ČR. FV panely a větrné mikroelektrárny na zelených střechách, bateriové úložiště o kapacitě 1 MW, spotové nákupy v době nízké ceny, nezávislý nouzový dieselagregát pro vlastní výrobu.'
  }, {
    icon: <DropletIcon className="w-8 h-8" data-id="element-85" />,
    title: 'Hospodaření s vodou',
    description: 'Trojstupňový systém: šedá recyklovaná voda pro splachování WC, bílá recyklovaná voda pro koupelny, sprchy, umyvadla a pračky, pitná voda z kvalitního zdroje Želivka. Recyklace až 37 % vody snižuje náklady na vodné i stočné.'
  }, {
    icon: <SmartphoneIcon className="w-8 h-8" data-id="element-86" />,
    title: 'Chytrá domácnost',
    description: 'Řízená spotřeba elektrické energie mimo energetické špičky – nastavení praní, sušení prádla, myček nádobí a dalších spotřebičů do režimu nízkého cenového pásma nákupu elektřiny. Klíče v mobilu i mechanické. Příprava pro SmartHome.'
  }, {
    icon: <TreesIcon className="w-8 h-8" data-id="element-87" />,
    title: 'Zelené střechy',
    description: 'Střešní plášť tvořený „zeleným sendvičem" snižujícím tepelné ztráty budovy až o 15 %. FV panely a solární kolektory, relaxační prostor s dokonalým výhledem a kavárnou na střeše, pěstování vlastní zeleniny.'
  }, {
    icon: <ShieldCheckIcon className="w-8 h-8" data-id="element-88" />,
    title: 'Prémiová konstrukce',
    description: 'Kompozitní výztuž místo betonářské oceli, speciální betonové směsi bez geopatogenních zón, dřevo-hliníková okna s trojskly 57 mm – o 10 % více světla a až 30% úspora energií. Splnění budoucích norem EU.'
  }, {
    icon: <WalletIcon className="w-8 h-8" data-id="element-89" />,
    title: 'Nízké provozní náklady',
    description: 'Předpokládané měsíční poplatky ca 60 % srovnatelné cenové hladiny. Fond oprav – první 3 roky nulový příspěvek díky vysoce kvalitním materiálům a smluvně garantovaným zárukám dodavatelů.'
  }];
  return <section id="vyhody" className="py-24 bg-base-cream" data-id="element-90">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-92">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-93">
            Proč Svatý Václav
          </h2>
          <p className="text-base-gray max-w-2xl mx-auto" data-id="element-94">
            Nejmodernější ekologické technologie pro bezkonkurenční komfort a
            úspory
          </p>
        </motion.div>

        {/* Image Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full h-64 md:h-96 rounded-2xl overflow-hidden mb-16 relative shadow-xl" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/v6gs57YcUP7SjvabVV3GrM/17.png" alt="Výhled z balkonu" className="w-full h-full object-cover" data-id="element-96" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-97">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group border border-primary/5" data-id="element-98">
              <div className="w-16 h-16 bg-primary/5 text-primary rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300" data-id="element-99">
                {feature.icon}
              </div>
              <h3 className="font-heading text-xl font-bold text-base-dark mb-3" data-id="element-100">
                {feature.title}
              </h3>
              <p className="text-base-gray leading-relaxed" data-id="element-101">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}